import type { AhPayload } from '../ahReport';
import { fmtNum } from '../utils';

export function BehaviourSection({ menuOpens }: { menuOpens: AhPayload['menuOpens'] }) {
  const max = Math.max(...menuOpens.breakdown.map((b) => b.count), 1);
  return (
    <section id="behaviour" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">04 — Gebruikersgedrag</div>
          <h2>Navigatie &amp; ondersteuning</h2>
        </div>
        <div className="description">
          Gebruikers openen het menu gemiddeld 0,4 keer per sessie. &ldquo;Hoe werkt het&rdquo; is consequent het populairste onderwerp.
        </div>
      </div>
      <div className="grid-1-2">
        <div className="card">
          <div className="card-head">
            <h3>Menu geopend</h3>
            <span className="meta">Totaal</span>
          </div>
          <div className="ah-stat-huge">{fmtNum(menuOpens.total)}</div>
          <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 12, lineHeight: 1.55 }}>
            Hamburger menu opens. Het hoge aantal &ldquo;Hoe werkt het&rdquo; suggereert dat onboarding nog verder verbeterd kan worden.
          </div>
        </div>
        <div className="card">
          <div className="card-head">
            <h3>Populairste menu-items</h3>
            <span className="meta">Verdeling</span>
          </div>
          <div className="hbar-list">
            {menuOpens.breakdown.map((b) => (
              <div className="hbar-row" key={b.label}>
                <span className="label">{b.label}</span>
                <div className="bar">
                  <div className="bar-fill" style={{ width: `${(b.count / max) * 100}%` }} />
                </div>
                <span className="v">{fmtNum(b.count)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
